export function isReplay3DRequested(search: URLSearchParams): boolean {
  return search.get("view") === "3d";
}

export function replay3DSearchParams(search: URLSearchParams, open: boolean): URLSearchParams {
  const next = new URLSearchParams(search);
  if (open) next.set("view", "3d");
  else next.delete("view");
  return next;
}
